import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  & > * {
    flex-grow: 1;
    padding: 20px;
  }
  @media (min-width: 426px) {
  }
  & ul {
    list-style: none;
    padding-left: 10px;
  }
`;

export const Form = styled.form`
  width: 100%;
  & > * {
    display: block !important;
    margin-bottom: 10px !important;
  }
`;

export const ChoosedPlan = styled.div`
  border-radius: 10px;
  padding: 10px;
  background: #294d7645;
  width: 250px;
`;
